import { uuid } from 'utils';
import { ISegmentFilter, ISegmentFilterType } from '../../entities/offsiteCampaign';
import { TFunction } from 'react-i18next';

interface SegmentType {
  heading: string;
  defaultValue: ISegmentFilter;
  creatable: boolean;
}

const segmentFilterTypeConfig = (
  t: TFunction<'campaigns'>,
  channel: string,
): { [key in ISegmentFilterType]: SegmentType } => {
  return {
    all: {
      heading: '',
      defaultValue: {
        id: uuid(),
        type: 'all',
        include: true,
        value: '',
        options: [],
        comparison: '',
      },
      creatable: false,
    },
    custom: {
      heading: t('offsiteEditor.segments.filters.customHeading'),
      defaultValue: {
        id: uuid(),
        type: 'custom',
        include: true,
        value: '',
        options: [],
        comparison: '',
      },
      creatable: true,
    },
    testing: {
      heading: t('offsiteEditor.segments.filters.testingHeading', { channel: channel === 'sms' ? 'SMS' : 'Email' }),
      defaultValue: {
        id: uuid(),
        type: 'testing',
        include: true,
        value: 'true',
        options: [],
        comparison: 'comparison',
        channel,
      },
      creatable: true,
    },
  };
};

export function getSegmentFilterConfig(
  segmentFilterType: string,
  t: TFunction<'campaigns'>,
  channel?: string,
): SegmentType {
  return segmentFilterTypeConfig(t, channel)[segmentFilterType];
}
